// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"639":"9f0f97ce","1143":"780f7786","2160":"863b54ed","2751":"69f93586","3116":"b4a65671","3295":"da837bbf","3866":"39bf59e1","4364":"76176f42","5469":"ddc7bf50","7556":"6a3346fc","7855":"07398162","9487":"3563b49c","9699":"eb823e94"}[chunkId] + ".chunk.js";
};